/* import __COLOCATED_TEMPLATE__ from './create-folder-button.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();